const footerOne = {
    logo: '/assets/img/logo-9.png',
    title_1: 'About Us',
    description: 'Subscribe to out newsletter today to receive updates on the latest news, releases and special offers respect your privacy.',
    title_2: 'Other Pages',
    widgetMenus: [
        {link:'/about',title:'About Us'},
        {link:'/blog-grid',title:'Blog'},
        {link:'/contact',title:'Contact Us'},
        {link:'/room-list',title:'Room List'},
    ],
    title_3: 'Gallery',
    title_4: 'Office Info',
    office_des: '1234 Lake Tahoe Blvd, South Lake Tahoe , California USA',
    officeInfos: [
        {link:'https://www.google.com/maps',info:'GXF4+8HQ Chippenham United Kingdom',icon: <i className="fal fa-map-marked-alt"></i>},
        {link:'mailto:info.help@gmail.com',info:'info.help@gmail.com',icon: <i className="fal fal fa-envelope-open-text"></i>},
        {link:'tel:+125(895)658568',info:'+125 (895) 658 568',icon: <i className='fal fa-phone-alt'></i>}
    ],
  }

  export default footerOne;